import Api from '@/vuex/api'

const api = new Api()

const UserStore = {
  userData: {},
  loggedIn: false,
  administrator: false,
  staff: false,
  manager: false,
  async refreshUser () {
    let account = {}
    try {
      account = await api.refreshLoggedInUser()
    } catch (err) {
      throw err
    }
    this.userData = account.object
    this.administrator = account.object.AccountType.administrator
    this.staff = account.object.AccountType.staff
    this.manager = account.object.AccountType.manager
    this.loggedIn = true
  },
  logout () {
    this.userData = {}
    this.administrator = false
    this.loggedIn = false
  }
}

const UserPlugin = {
  install (Vue) {
    Vue.mixin({
      data () {
        return {
          userStore: UserStore
        }
      }
    })
    Object.defineProperty(Vue.prototype, '$user', {
      get () {
        return this.$root.userStore
      }
    })
  }
}

export default UserPlugin



// WEBPACK FOOTER //
// ./src/userPlugin.js